import * as utils from "../misc.js";
//import * as lazyload from "../plugins/lazyload.js";

export function init_priceslider(min, max) {

    jQuery('.price-slider').slider({
        range: true,
        min: min - 1,
        max: max,
        values: [min, max],
        create: function () {
            jQuery('.price_label span.from').html('$' + min);
            jQuery('.price_label span.to').html('$' + max);
        },
        stop: function (event, ui) {
            jQuery(this).attr("data-min", ui.values[0]);
            jQuery(this).attr("data-max", ui.values[1]);
            jQuery(".woo_filters").attr("data-pageno", 1);
            do_woofilter(2000);
            // const setpricefiltertimeout = setTimeout(() => {
            //     do_woo_filters();
            //     clearTimeout(setpricefiltertimeout)
            // }, 2000)
        },
        slide: function (event, ui) {
            jQuery('.price_label span.from').html('$' + ui.values[0]);
            jQuery('.price_label span.to').html('$' + ui.values[1]);


        }
    });
}



export function loadPriceSlider(pricelow, pricehigh) {
    var current_min_price = pricelow,
        current_max_price = pricehigh;

    if (pricelow == -1 && pricehigh == -1) {
        if (jQuery(".price-slider").length > 0) {
            current_min_price = jQuery(".price_label span.from").html().replace(/[^\d.-]/g, '');
            current_max_price = jQuery(".price_label span.to").html().replace(/[^\d.-]/g, '');
        }
    }

    if (jQuery('.price-slider').length > 0) {
        init_priceslider(current_min_price, current_max_price)
    }
}

function do_woofilter(timeout) {

    const setpricefiltertimeout = setTimeout(() => {
        do_woo_filters();
        clearTimeout(setpricefiltertimeout)
    }, timeout)

}
export function init() {

    loadPriceSlider(-1, -1);
    
    jQuery(".woo_filters input[name='filtersearch']").on("change", function () {
        jQuery(".woo_filters").attr("data-pageno", 1);
        do_woofilter(500);
    });

    jQuery(".woo_filters ul li").on("click", function () {
        jQuery(this).toggleClass("active");

        jQuery(".woo_filters").attr("data-pageno", 1);
        do_woofilter(500);
    });

    jQuery(".productsblock").on("click", ".woocommerce-pagination ul li a", function (e) {
        if (jQuery(".woo_filters").length > 0) {
            e.preventDefault();
            var pageno = jQuery(this).html();

            jQuery(".woo_filters").attr("data-pageno", pageno);
            do_woo_filters();
        }

    })
}

function do_woo_filters() {

    jQuery("ul.products").addClass("loading");
    jQuery("ul.products").prepend("<div class='loading-ring'></div>");
    jQuery("ul.products li").hide();
    var filters = [];
    var tax = jQuery(".woo_filters").data("tax");
    var term = jQuery(".woo_filters").data("term");
    var perpage = jQuery(".woo_filters").data("perpage");
    var pageno = jQuery(".woo_filters").attr("data-pageno");
    var pricefrom = jQuery(".price-slider").attr("data-min")
    var priceto = jQuery(".price-slider").attr("data-max");
    var saleonly = jQuery(".woo_filters").attr("data-saleonly")
    var s = jQuery("input[name='filtersearch']").val();
    var orderby = jQuery(".woocommerce-ordering .orderby").find("option:selected").val();

    var filtergroupArr = [];

    jQuery(".woo_filters").find("div.filtergroup").each(function () {
        var filtergroupid = jQuery(this).data("attrgroup");

        var filtergroupvals = []

        jQuery(this).find("li.active").each(function () {
            var filterid = jQuery(this).data("attval");
            filtergroupvals.push(filterid);
        });

        if (filtergroupvals.length) {
            filtergroupArr.push({ "filtergroup": filtergroupid, "values": filtergroupvals });
        }
    })

    utils.scrollTo(".woocommerce-product-results", 50)

    jQuery.post(base.ajaxurl, {
        action: "woo_getproducts",
        tax,
        term,
        perpage,
        pageno,
        s,
        pricefrom,
        priceto,
        saleonly,
        orderby,
        filters: filtergroupArr
    }, function (r) {
        var r = JSON.parse(r);
        if (r) {
            var from = r.from;
            var to = r.to;
            var total = r.total;
            jQuery("ul.products").html(r.productsHTML);
            jQuery(".woocommerce-result-count").html(`Showing ${from}-${to} of ${total} results`);
            var paginationHTML = "";

            for (var a = 1; a <= Math.ceil(total / perpage); a++) {

                var thisclass = (a == pageno) ? "class='current'" : "";
                paginationHTML += `<li><a ${thisclass}>${a}</a></li>`;

            }
            if (jQuery(".woocommerce-pagination ul").length == 0) {
                jQuery(".productsblock").append("<nav class='woocommerce-pagination'><ul class='page-numbers'>"+paginationHTML+"</ul></nav>");
            }else{
                jQuery(".woocommerce-pagination ul").html(paginationHTML);
            }
            
            jQuery("ul.products").removeClass("loading");
            
        }
    });


}

